import { BtnLoader } from "../Loader/BtnLoader"

interface CNotificationProps {
    visible: boolean,
    isLoading: boolean,
    message:string ,
}


export const CNotification = ({ visible, isLoading , message }: CNotificationProps) => {

    return (
        <>
            <div className={`w-[200px] max-w-[90%]  h-[50px] text-sm text-white flex items-center justify-center bg-trade-25 rounded-md border-l-[4px] border-trade-75 fixed right-5 transition-all duration-500 delay-200 z-50 ${visible ? 'bottom-5 opacity-100 visible' : 'bottom-0 opacity-0 invisible'}`}>
                {isLoading &&
                    <div className="w-[40px]">
                        <BtnLoader />
                    </div>
                }
                <span>{message}</span>
            </div>

        </>
    )
}